var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"migrants_wrap"},[_c('ioc-table',{ref:"refPeoPleTable",attrs:{"data":_vm.migrantsTableData,"option":_vm.constData.migrantsTable,"page":_vm.constData.migrantsPage},on:{"search-change":(val) => {
        _vm.handleSearchChange(val, 'migrants');
      },"search-reset":(val) => {
        _vm.handleSearchReset('migrants');
      },"size-change":(val) => {
        _vm.handleSizeChange(val, 'migrants');
      },"current-change":(val) => {
        _vm.handleCurrentChange(val, 'migrants');
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }